import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Landing.module.css';
import buttonStyles from '../styles/modules/Button.module.css';
import backgroundImage from '../images/background.jpg';
import logoImage from '../images/logo.jpg';

const Landing: React.FC = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value);
    };

    const handleGoClick = () => {
        navigate('/signin');
    };

    return (
        <div className={styles.landingPage} style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className={styles.languageSelector}>
                <select value={i18n.language} onChange={handleLanguageChange}>
                    <option value="en">English</option>
                    <option value="sr">Srpski</option>
                </select>
            </div>
            <div className={styles.logoContainer}>
                <div className={styles.logoBox}>
                    <img src={logoImage} alt="Easy Staff Logo" className={styles.logoImage} />
                </div>
            </div>
            
            <div className={styles.content}>
                <h1 className={styles.mainTitle}>
                    <span className={styles.titleFind}>{t('landing.title')}</span>
                </h1>
                
                <button className={buttonStyles.accent} onClick={handleGoClick}>{t('landing.getStarted')}</button>
            </div>
        </div>
    );
};

export default Landing;
